module.exports = __webpack_public_path__ + "img/0S6A9812.b99c3f78.jpg";